export const SIGNUP = {
  TITLE: 'Registrarse',
  USERNAME: 'Nombre de usuario',
  PASSWORD: 'Contraseña',
  EMAIL: 'Correo electrónico',
  FULL_NAME: 'Nombre completo',
  BUTTON: 'Registrarse',
  SUCCESS: 'Registro exitoso',
}

export const RESET_PASSWORD = {
  TITLE: 'Restablecer contraseña',
  EMAIL: 'Correo electrónico',
  BUTTON: 'Restablecer contraseña',
  EMAIL_SENT: 'Correo de restablecimiento enviado, por favor revisa tu bandeja de entrada',
  NEW_PASSWORD: 'Nueva contraseña',
  PASSWORD_UPDATED: 'Contraseña actualizada, por favor inicia sesión nuevamente',
  INVALID_TOKEN: 'Tu token es inválido, puede que haya expirado. Por favor, intenta nuevamente',
  PASSWORD_UPDATE_FAILED: 'Error al actualizar la contraseña',
  MAIL: {
    SUBJECT: 'Restablece tu contraseña',
    BODY: (url: string) => `Haz clic <a href="${url}">aquí</a> para restablecer tu contraseña`,
  },
}

export const GOOGLE_SSO_SUCCESS = {
  TITLE: 'Inicio de sesión con Google exitoso',
  SUBTITLE: 'Te has autenticado con Google',
  BUTTON: 'Cerrar ventana',
}

export const LOGIN = {
  WELCOME: '¡Bienvenido de nuevo!',
  TITLE: 'Inicia sesión en Qalea',
  EMAIL: 'Introduce tu correo electrónico',
  BUTTON: 'Envíame el enlace de inicio de sesión',
  GOOGLE_SSO_BUTTON: 'Iniciar sesión con Google',
  MICROSOFT_SSO_BUTTON: 'Iniciar sesión con Microsoft',
  PROBLEMS_LOGIN: '¿Problemas para iniciar sesión?',
  CLICK_HERE: 'Haz clic aquí',
  OR_DIVIDER: 'o',
  DESCRIPTION: '¿Necesitas una cuenta?',
  CONTACT: 'Habla con nosotros',
  REDIRECTING: 'Redirigiendo a tu cuenta...',
  USER_NOT_FOUND: 'Parece que no tenemos ningún usuario con este correo en nuestro sistema',
  MAGIC_LINK_SUBJECT: 'Enlace mágico de Qalea',
  MAGIC_LINK_ERROR: 'Error al enviar el enlace mágico',
  MAGIC_LINK_TEXT: (url: string, userFullName: string | null, orgName: string) => `
  <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
    <p>Hola ${userFullName},</p>
    <p>
    Por favor, haz clic en el enlace de abajo para iniciar sesión en tu cuenta como usuario de ${orgName}:
    </p>
    <p><a href="${url}" style="color: #007bff; text-decoration: none;">Iniciar sesión en Qalea</a></p>
    <p>Si no solicitaste este enlace, puedes ignorar este correo de forma segura.</p>
    <p>Gracias,<br>Equipo Qalea</p>
  </div>
`,
  MAGIC_LINK_SENT: 'Enlace mágico enviado, por favor revisa tu bandeja de entrada',
  SSO_FAILED: 'El inicio de sesión único falló. Por favor, intenta nuevamente o contáctanos.',
  ERROR: 'Algo salió mal, por favor intenta nuevamente',
}

export const SYSTEM_USE_NOTICE = {
  TITLE: 'Aviso de uso del sistema',
  MESSAGE:
    'El acceso y uso de este sistema está sujeto a las condiciones de uso establecidas por Qalea. Al acceder, usted declara conocer y aceptar dichas condiciones, así como las responsabilidades derivadas de su uso.',
  MESSAGE_AUDIT:
    'El sistema puede registrar la actividad de los usuarios con fines de seguridad y auditoría. Para más información, consulte nuestras',
  TERMS_OF_SERVICE: 'Condiciones de Uso',
  PRIVACY_POLICY: 'Política de Privacidad',
  AND: 'y',
  ACCEPT: 'Aceptar',
}
